// Cloned from https://github.com/jaredLunde/react-hook/blob/master/packages/merged-ref/src/index.tsx to circumvent import issues
import React from 'react';
export function useMergedRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return React.useCallback(function (element) {
    for (var i = 0; i < refs.length; i++) {
      var ref = refs[i];

      if (typeof ref === 'function') {
        ref(element);
      } else if (ref && typeof ref === 'object') {
        ref.current = element;
      }
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  refs);
}